import numeral from 'numeral';
import moment from 'moment';

//formats currency
export function formatCurrency(price) {
    return (price).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
}

//checks if prescription is required
export function prescription(val) {
    if (val === true) {
        return 'Presciption Required';
    }
}

export function dateFormatter(date) {
    return moment(date)
        .format('MMMM Do YYYY');
}

//checks if item is in stock and produces the result based on the check
export function stock(price) {
    if (price > 0) {
        return 'In Stock';
    } else {
        return 'Out of Stock';
    }
}

export function capitalize(string) {
    return string.charAt(0)
        .toUpperCase() + string.slice(1);
}

export function formatPrice(price, space = true, sign = true) {
    const numberWithCommas = numeral(price)
        .format('0,0.00');
    return space ? `${sign ? '$ ' : ''}${numberWithCommas}` : `${sign ? '$' : ''}${numberWithCommas}`;
}

// export function handleResize(){
//     window.addEventListener('resize', handleResize);
//     return window.innerWidth;
// }
